import React from 'react';
import PropTypes from 'prop-types';
import { TimelineWrapper, TimelineHeading, ListWrapper } from './styles';
import RichText from '../rich-text';
import TimelineItem from './timeline-item';
import { consistentString, sanitizeId } from '../../utils/content-formatting';

const Timeline = ({ timelineHeading, listType = 'bullets', items }) => {
  if (!items) return null;
  const isBulletedList = consistentString(listType) === 'bullets';
  return (
    <TimelineWrapper>
      {timelineHeading ? (
        <TimelineHeading>{timelineHeading}</TimelineHeading>
      ) : null}
      <ListWrapper as={isBulletedList ? 'ul' : 'ol'}>
        {items.map(({ heading, content }, i) => (
          <TimelineItem
            hasTimelineHeading={!!timelineHeading}
            isBulletedList={isBulletedList}
            heading={heading}
            itemNumber={i + 1}
          >
            <RichText
              linkData={{
                tracking: `timeline-link-${sanitizeId(heading).slice(0, 30)}`,
              }}
              richText={content}
            />
          </TimelineItem>
        ))}
      </ListWrapper>
    </TimelineWrapper>
  );
};

Timeline.propTypes = {
  timelineHeading: PropTypes.string,
  listType: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      content: PropTypes.object,
    })
  ),
};

export default Timeline;

export const TimelineAssembly = ({ contentfulData }) => (
  <Timeline
    timelineHeading={contentfulData.timelineHeading}
    listType={contentfulData.listType}
    items={contentfulData.items}
  />
);

TimelineAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
